import { IS_PROD } from 'src/interviews/requests/settings';

export const STRIPE_PUBLISHABLE_KEY = IS_PROD
  ? 'pk_live_ohbnZE1u6Ynfx4cNjTmPTi1W'
  : 'pk_test_jHWdCPvVYCcYJ5TXx9z4AQeP';

export const DX_CONFIRMATION_PRODUCT_ID = IS_PROD ? 'prod_Qu5QzOlu5fTW9P' : 'prod_QuOqdp6Ej016k4';
export const PRODUCT_DESCRIPTION = 'Doctor Review & Confirmation';
